import * as React from 'react';
import { useSelector } from 'react-redux';

import { ToggleButton as ToggleButtonComponent } from '../../components/NewbuildingPromos/ToggleButton';
import { QUANTITY_PROMOS_IN_ROW } from '../../components/NewbuildingPromos/parts/constants';
import { getNewbuildingPromos } from '../../selectors/newObject';
import { pluralize } from '../../utils/pluralize';

interface IToggleButtonProps {
  opened: boolean;
  onClick(): void;
}

export const ToggleButton = (props: IToggleButtonProps) => {
  const count = useSelector(getNewbuildingPromos).length;

  return (
    <ToggleButtonComponent
      {...props}
      closedText={`Показать еще ${pluralize(count - QUANTITY_PROMOS_IN_ROW, ['акцию', 'акции', 'акций'])}`}
    />
  );
};
